<template>
	<v-dialog v-model="isVisible" max-width="600">
		<p-card class="tw-p-none overflow-hidden">
			<p-header-dialog :negative-margin="false" @closeClicked="close()">
				Agregar Nuevo Item
			</p-header-dialog>
			<section class="tw-flex tw-justify-between tw-items-center tw-gap-2 tw-p-4">
				<label :style="`color:${$appColors.info}; width: 100%;`">Nombre:
					<v-text-field
						label="Nombre"
						solo
						hide-details
						class="input-text"
						v-model="verb.name"
					></v-text-field>
					<span
						v-if="$v.verb.name.$invalid"
						class="message-error"
						:style="`color:${$appColors.error}`"
					>
						El nombre es requerido
					</span>
				</label>
			</section>
			<p-horizontal-divider></p-horizontal-divider>
			<div class="tw-flex tw-justify-center tw-items-center tw-pb-4">
				<p-button
					:disabled="fieldsNone"
					type="primary"
					@click="saveNewItem"
					> Guardar
				</p-button>
			</div>
		</p-card>
	</v-dialog>
</template>

<script>
import PCard from '@/modules/shared/components/ui/Card/p-card';
import PHorizontalDivider from '@/modules/shared/components/ui/p-horizontal-divider';
import CloseIcon from '@/modules/shared/components/icons/close-icon';
import PButton from '@/modules/shared/components/ui/p-button';
import PHeaderDialog from '@/modules/shared/components/ui/dialog/p-header-dialog';
import { required } from 'vuelidate/lib/validators';

export default {
	name: 'add-new-item-dialog',
	created() {
		this.verb = this.verbP;
	},
	data() {
		return {
			isVisible: false,
			verb: {
				name: null,
			},
		};
	},
	components: { PHeaderDialog, PButton, CloseIcon, PCard, PHorizontalDivider },
	methods: {
		open() {
			this.isVisible = true;
		},
		close() {
			this.isVisible = false;
		},
		saveNewItem() {
			this.verb.code = this.category.code;
			this.$emit('addNewVerb', this.verb);
			this.close();
		},
	},
	computed: {
		fieldsNone() {
			return !this.verb.name;
		},
	},
	props: {
		verbP: {
			type: Object,
			default: () => {},
		},
		category: {
			type: Object,
			default: () => {},
		},
	},
	validations() {
		return {
			verb: {
				name: { required },
			},
		};
	},
};
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/configuration/general-data/add-new-item-dialog.vue